
<app-page-wrapper>
    <div *ngIf="!isLoading" class="watcher-wrapper">

        <div class="watcher-header">
            <div class="header-text">Discovered Options</div>
            <app-section-label weight="200">
                Your agent found these travel plans for you to consider
            </app-section-label>
        </div>

        <div class="provider-filter" *ngIf="shouldShowProviderFilter">
            <div class="filter-copy">
                <div class="filter-title">Provider filter</div>
            </div>
            <app-toggle-item-row class="provider-filter-control" [(value)]="selectedProvider" [options]="providerOptions" iconURL="assets/svg/filter-outline.svg" [fullWidth]="true" (valueChange)="onFilterValueChange()"></app-toggle-item-row>
        </div>

        <div class="watcher-results">
            <div class="items" *ngIf="filteredWatcherFlights?.length > 0; else emptyExact">
                <app-flight-option-card *ngFor="let f of filteredWatcherFlights" [flightOption]="f"
                    (click)="onClickOption(f)"></app-flight-option-card>
            </div>
    
            <ng-template #emptyExact>
                <div id="r-card" class="empty-state">
                    <div>No options for {{ selectedProviderLabel }}</div>
                    <button type="button" *ngIf="selectedProvider !== 'All & Independent'" (click)="clearProviderFilter()">Show all providers</button>
                </div>
            </ng-template>
    
        </div>
    
    </div>

    <app-request-connection-overlay *ngIf="appState.agent.selectedOption()" [userFlightOption]="userFlightOption"></app-request-connection-overlay>

</app-page-wrapper>
